<section class="order-book-shell">
    <main class="workspace">
        <nav class="top-tabs">
            <button class="tab active">Orderbuch</button>
            <button class="tab">Portfolio Aktionen</button>
            <button class="tab">Anlagestrategien</button>
            <button class="tab">Order Bestätigung</button>
            <button class="tab">Order Matching</button>
            <button class="tab">Orderkörbe</button>
        </nav>

        <header class="toolbar">
            <div class="toolbar-row">
                <button class="icon-button">↺</button>
                <div class="segmented">
                    <button>Order Status</button>
                    <button class="selected">Übermittelt</button>
                    <button>Abgeschlossen</button>
                    <button>Fehlgeschlagen</button>
                    <button>Storniert</button>
                    <button>Unbekannt</button>
                </div>
                <button class="filter-button">Portfolio⌄</button>
                <button class="filter-button">Wertpapier⌄</button>
                <button class="filter-button">Erstellungsdatum⌄</button>
                <button class="filter-button">Erstellt von⌄</button>
                <button class="filter-button">Ausführungsstatus⌄</button>
                <button class="filter-button">Broker Konfiguration⌄</button>
                <label class="search">
                    <span>⌕</span>
                    <input placeholder="External ID" />
                </label>
                <button class="icon-button">⊕</button>
                <button class="icon-button">🛒</button>
                <button class="primary-button">🛒 Kauf</button>
                <button class="primary-button">🛒 Verkauf</button>
                <button class="icon-button">⋮</button>
            </div>

            <div class="toolbar-row secondary">
                <button class="filter-button">Vertriebsstrategie⌄</button>
                <button class="filter-button wide">Interner Kommentar fehlt <span class="toggle"></span></button>
                <button class="filter-button">Contact Log⌄</button>
                <button class="filter-button wide">Heuristiken anzeigen <span class="toggle"></span></button>
            </div>

            <div class="chips">
                <span class="chip">Order Status: <strong>Übermittelt</strong> ×</span>
                <button class="refresh-chip">↻</button>
            </div>
        </header>

        <div class="content-grid">
            <section class="table-card">
                <div class="table-wrapper">
                    <table>
                        <thead>
                        <tr>
                            <th class="expand-cell"></th>
                            <th>Wertpapier<br /><small>ISIN/WKN</small></th>
                            <th>Typ</th>
                            <th>Vermögensträger<br /><small>Portfolio</small></th>
                            <th>Konto</th>
                            <th>Handelsplatz<br /><small>Broker</small></th>
                            <th>Übermittelt am<br /><small>Gültig bis</small></th>
                            <th>Orderbetrag<br /><small>Einheiten</small></th>
                            <th>Ausführungskurs<br /><small>Geplanter Kurs</small></th>
                            <th>Limit<br /><small>Stop</small></th>
                            <th>Order Status<br /><small>Ausführungsstatus</small></th>
                            <th>Aktionen</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr
                                *ngFor="let row of orders"
                                [class.selected-row]="selected.id === row.id"
                                (click)="selectOrder(row)"
                        >
                            <td class="expand-cell">›</td>
                            <td>
                                <strong>{{ row.instrument }}</strong>
                                <span>ISIN: {{ row.isin }}</span>
                                <span>WKN: {{ row.wkn }}</span>
                            </td>
                            <td>
                                <div class="type-wrap">
                                    <span class="badge" [class.sell]="row.side === 'Verkauf'">{{ row.side[0] }}</span>
                                    <div>
                                        <strong>{{ row.type }}</strong>
                                        <span>{{ row.instrumentType }}</span>
                                        <span>Extern</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <strong>{{ row.custodian }}</strong>
                                <span>{{ row.portfolio }}</span>
                            </td>
                            <td><strong>{{ row.account }}</strong></td>
                            <td>
                                <strong>{{ row.venue }}</strong>
                                <span>{{ row.broker }}</span>
                            </td>
                            <td>
                                <strong>{{ row.submittedDate }}</strong>
                                <span>{{ row.validUntil }}</span>
                            </td>
                            <td>
                                <strong>{{ row.amount }}</strong>
                                <span>{{ row.quantity }}</span>
                            </td>
                            <td>
                                <strong>{{ row.executionPrice || '-' }}</strong>
                                <span>{{ row.plannedPrice || '-' }}</span>
                            </td>
                            <td>
                                <strong>{{ row.limit || '-' }}</strong>
                                <span>-</span>
                            </td>
                            <td>
                                <strong>{{ row.status }}</strong>
                                <span class="status-line"></span>
                                <span>{{ row.executionStatus || '-' }}</span>
                            </td>
                            <td class="actions" (click)="$event.stopPropagation()">
                                <button title="Details">⌕</button>
                                <button title="Delete" *ngIf="row.id < 8">♧</button>
                                <button title="Comment" *ngIf="row.id === 5 || row.id === 6 || row.id === 7">☏</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <aside class="details-panel" *ngIf="selected as order">
                <header>
                    <h2>Orderdetails</h2>
                    <div>
                        <button class="icon-button small">⧉</button>
                        <button class="icon-button small">⋮</button>
                    </div>
                </header>

                <dl class="details-grid">
                    <div>
                        <dt>Wertpapier</dt>
                        <dd>
                            <strong>{{ order.instrument }}</strong><br />
                            ISIN: {{ order.isin }}<br />
                            WKN: {{ order.wkn }}
                        </dd>
                    </div>
                    <div>
                        <dt>Handelsplatz</dt>
                        <dd>{{ order.venue }}</dd>
                    </div>
                    <div>
                        <dt>Vermögensträger</dt>
                        <dd>{{ order.custodian }}</dd>
                    </div>
                    <div>
                        <dt>Portfolio</dt>
                        <dd>{{ order.portfolio }}</dd>
                    </div>
                    <div>
                        <dt>Broker</dt>
                        <dd>{{ order.broker }}</dd>
                    </div>
                    <div>
                        <dt>Konto</dt>
                        <dd>{{ order.account }}</dd>
                    </div>
                    <div>
                        <dt>Geschäftsart</dt>
                        <dd><span class="badge compact">{{ order.side[0] }}</span> {{ order.side }}</dd>
                    </div>
                    <div>
                        <dt>Ordertyp</dt>
                        <dd>{{ order.type }}</dd>
                    </div>
                    <div>
                        <dt>Orderbetrag</dt>
                        <dd>{{ order.amount }}</dd>
                    </div>
                    <div>
                        <dt>Orderstücke</dt>
                        <dd>{{ order.quantity }}</dd>
                    </div>
                    <div>
                        <dt>Ausgeführt</dt>
                        <dd>0 Stücke</dd>
                    </div>
                    <div>
                        <dt>Ausführungsquote</dt>
                        <dd>0%</dd>
                    </div>
                    <div>
                        <dt>Limit</dt>
                        <dd>{{ order.limit || '-' }}</dd>
                    </div>
                    <div>
                        <dt>Stop</dt>
                        <dd>-</dd>
                    </div>
                    <div>
                        <dt>Erstellt am</dt>
                        <dd>{{ order.submittedDate }}, 1:11 PM</dd>
                    </div>
                    <div>
                        <dt>Gültig bis</dt>
                        <dd>{{ order.validUntil }}</dd>
                    </div>
                    <div>
                        <dt>External ID</dt>
                        <dd>{{ order.externalId || '-' }}</dd>
                    </div>
                    <div>
                        <dt>Erstellt von</dt>
                        <dd>{{ order.createdBy || 'Marco Rinne' }}</dd>
                    </div>
                    <div>
                        <dt>Bemerkung</dt>
                        <dd>-</dd>
                    </div>
                    <div>
                        <dt>Ausführungshinweis</dt>
                        <dd>-</dd>
                    </div>
                    <div>
                        <dt>Interner Kommentar</dt>
                        <dd>-</dd>
                    </div>
                    <div>
                        <dt>Vertriebsstrategie</dt>
                        <dd>-</dd>
                    </div>
                    <div class="wide-detail">
                        <dt>Order Status</dt>
                        <dd>{{ order.orderStatusRaw || 'OrderRequested' }}</dd>
                    </div>
                </dl>
            </aside>
        </div>
    </main>
</section>
